// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "application." + "35f3bc629d000e0d2c50" + ".css";
};